




















































































import { Component, Emit, Vue } from 'vue-property-decorator';
import { privateNetworkService } from '@/components/network/private-network/services/PrivateNetworkService';
import { publicIPAddressService } from '@/components/network/public-ip-address/services/PublicIPAddressService';

@Component({
  props: ['network'],
})
export default class AddNewPrivateNetworkDialog extends Vue {
  workspaceId = 0;
  regionId = 0;
  privateNetworkName: string = '';
  addressing: string = '';
  publicIpAddress = '';
  publicIpAddressesForSelect = {};
  validation: boolean = false;
  addressingError: any = '';
  addressingRegex: boolean = true;
  isLoading: boolean = false;
  isNewPNAddingTriggered: boolean = false;

  clearForm() {
    this.privateNetworkName = '';
    this.addressing = '';
    this.publicIpAddress = '';
    this.onCancel();
  }

  @Emit()
  onCancel() {
    return;
  }

  @Emit()
  onClose() {
    return;
  }

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    this.isNewPNAddingTriggered = false;
    this.getPublicIpAddresses();
  }

  getPublicIpAddresses() {
    publicIPAddressService.getPublicIPAddresses(this.workspaceId, this.regionId).then((data: any) => {
      this.publicIpAddressesForSelect = data.public_ip_addresses.filter((ip: any) => ip.state === 'idle');
    });
  }

  create() {
    this.validation = true;
    this.addressingError = '';
    this.addressingRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[1-2][0-9]|[0-9])$/.test(
      this.addressing
    );
    if (!this.addressingRegex || !this.addressing || !this.privateNetworkName || !this.publicIpAddress) {
      return;
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    privateNetworkService
      .createPrivateNetwork(this.workspaceId, this.regionId, {
        name: this.privateNetworkName,
        network: this.addressing,
        public_ip_address_id: this.publicIpAddress,
        type: 'dedicated',
      })
      .then(() => {
        this.isLoading = false;
        this.validation = false;
        this.isNewPNAddingTriggered = true;
      })
      .catch(err => {
        this.isLoading = false;
        if (err.status === 422) {
          this.addressingError = this.$t('error.network.' + err.data.error.network[0].error);
        }
      });
  }
}
